import { StatementItemSnapshot, StatementItemType } from '../../../../models/account-statement'

export function getStatementItemPrefix(item: StatementItemSnapshot) {
  if (item.type === StatementItemType.Invoice) {
    return 'INV'
  }

  return 'CN'
}
